import { TimePointSchema } from '../../requests/api/apiTypes';

export type ModalState = {
  open: boolean;
  conversationId: string;
  timePointData: TimePointSchema;
};

export const EMPTY_MODAL_STATE: ModalState = {
  open: false,
  conversationId: '',
  timePointData: {
    hour: '',
    day: '',
    month: '',
    year: '',
  },
};
